var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',_vm._g(_vm._b({attrs:{"name":"slide-from-top"}},'transition-group',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }